'use strict';
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-sanitize/index.js
// module id = 172
// module chunks = 96961042003272 139266963665775